import {
  tokens,
  makeStyles,
  shorthands,
  Card,
  Text,
  Button,
} from '@fluentui/react-components';
import { ShieldLockRegular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  page: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fff5f5 0%, #fef0f0 40%, #f5f0ff 100%)',
    ...shorthands.padding('24px'),
  },
  card: {
    maxWidth: '420px',
    width: '100%',
    ...shorthands.padding('48px', '40px'),
    ...shorthands.borderRadius('16px'),
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08), 0 0 1px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    border: 'none',
  },
  iconWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '64px',
    height: '64px',
    ...shorthands.borderRadius('16px'),
    backgroundColor: tokens.colorPaletteRedBackground2,
    color: tokens.colorPaletteRedForeground1,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '24px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 700,
    color: tokens.colorNeutralForeground1,
    marginBottom: '8px',
  },
  description: {
    fontSize: '14px',
    color: tokens.colorNeutralForeground3,
    lineHeight: '20px',
    marginBottom: '32px',
  },
  signOutBtn: {
    width: '100%',
    height: '40px',
    ...shorthands.borderRadius('8px'),
  },
});

interface AccessDeniedScreenProps {
  onSignOut: () => void;
}

export function AccessDeniedScreen({ onSignOut }: AccessDeniedScreenProps) {
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <Card className={styles.card}>
        <div className={styles.iconWrap}>
          <ShieldLockRegular fontSize={32} />
        </div>
        <Text className={styles.title} block>
          Access Denied
        </Text>
        <Text className={styles.description} block>
          Your account does not have access to this application. Please contact your administrator
          to be assigned access in the Entra app registration.
        </Text>
        <Button appearance="secondary" className={styles.signOutBtn} onClick={onSignOut}>
          Sign out
        </Button>
      </Card>
    </div>
  );
}
